import errorMessages from 'consts/errorMessageConsts';

export const selectModalDisplay = state => state.modal && state.modal.display;
export const selectModalContent = state => state.modal && state.modal.content;
export const selectModalZipcodeErrorContent = state =>
  state.modal && state.modal.content === errorMessages.INVALID_ZIP;
